import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import UserProfileModal from './UserProfileModal';
import './ParticipantSlider.css';

const ParticipantSlider = ({ participants, creatorId }) => {
    const { t } = useTranslation();
    const sortedParticipants = [
        ...participants.filter(p => p.user_id === creatorId),
        ...participants.filter(p => p.user_id !== creatorId)
    ];

    const dragConstraints = {
        right: 0,
        left: - (sortedParticipants.length * 100 - (window.innerWidth > 500 ? 500 : window.innerWidth) + 40),
    };

    const [profileUser, setProfileUser] = useState(null);

    const handleClickAvatar = (user) => {
        setProfileUser(user);
    };

    return (
        <>
        <div className="slider-container">
            <motion.div 
                className="slider-track"
                drag="x"
                dragConstraints={dragConstraints}
                dragTransition={{ bounceStiffness: 300, bounceDamping: 20 }}
            >
                {sortedParticipants.map((p) => (
                    <motion.div className="participant-card-new" key={p.user_id}>
                        <img 
                            src={p.selfie_path ? p.selfie_path : 'https://placehold.co/80x80/1e1e1e/444?text=?'} 
                            alt={p.nickname} 
                            className="participant-image-new" 
                            onClick={() => handleClickAvatar(p)}
                            style={{ cursor: 'pointer' }}
                        />
                        <span className="participant-name-new">
                          {p.nickname}
                          {p.user_id === creatorId ? ` ${t('participant_host', '(Host)')}` : ''}
                        </span>
                    </motion.div>
                ))}
            </motion.div>
        </div>
        {profileUser && <UserProfileModal user={profileUser} onClose={() => setProfileUser(null)} />}
        </>
    );
};

export default ParticipantSlider;






